import {
  noSelectionKey,
  showSelectedKleHierarchies,
  showUnselectedKleHierarchies,
} from '../../../../utilities/filterAndSortingsUtil';

export const filterKleHierarchyItems = (
  titleFilter,
  mainNumberFilter,
  subNumberFilter,
  isChosenFilter,
  listOfSelectedItems,
) => (kleHierarchy) => {
  if (
    isChosenFilter === showSelectedKleHierarchies &&
    !listOfSelectedItems.some((itemId) => itemId === kleHierarchy.key)
  ) {
    return false;
  }

  if (
    isChosenFilter === showUnselectedKleHierarchies &&
    listOfSelectedItems.some((itemId) => itemId === kleHierarchy.key)
  ) {
    return false;
  }

  if (
    mainNumberFilter !== noSelectionKey &&
    kleHierarchy.number.substring(0, 2) !== mainNumberFilter
  ) {
    return false;
  }

  if (
    subNumberFilter !== noSelectionKey &&
    kleHierarchy.number.substring(0, 5) !== subNumberFilter
  ) {
    return false;
  }

  if (
    titleFilter !== noSelectionKey &&
    !(
      kleHierarchy.name &&
      kleHierarchy.name.toLowerCase().includes(titleFilter.toLowerCase())
    )
  ) {
    return false;
  }

  return true;
};

export const filterKleHierarchyMainGroupNumbers = (kleHierarchy) =>
  kleHierarchy.number && kleHierarchy.number.length === 2;

export const filterKleHierarchySubGroupNumbers = (filter) => (kleHierarchy) =>
  kleHierarchy.number &&
  kleHierarchy.number.length === 5 &&
  kleHierarchy.number.substring(0, 2) === filter;
